import React, { useState } from "react";
import ReactDOM from "react-dom";
import TicketModal from "../../../shared/components/TicketModal/main";
import { useReactAppState } from "../../../shared/containers/utils";
import Chevron from "./Chevron";
import {
  StyledMatchCTA,
  StyledMatchWatchPre,
  StyledMatchWatchPreLabel,
  StyledMatchWatchPreWrapper,
} from "./StyledMatchWatch";
import { getTicketMasterIconUrl, getTicketMasterUrl } from "../../../shared/utils";
import { TicketIconV2 } from "../../../shared/svg/TicketIconV2/TicketIconV2";

  
export const MatchWatchPre = ({
  firstPartyTickets,
  thirdPartyTickets,
  trackFn = () => null,
  showChevron = false,
}) => {
  const { t } = useReactAppState();
  const [renderPortal, setRenderPortal] = useState(false);
  const ticketMasterIconUrl = getTicketMasterIconUrl({ variant: "dark" });
  const hasTicketMasterUrl = getTicketMasterUrl([firstPartyTickets?.url, thirdPartyTickets?.url]);


  const handleClick = () => {
    trackFn();

    if (firstPartyTickets?.url && thirdPartyTickets?.url) {
      setRenderPortal(true);
    } else {
      window.open(firstPartyTickets?.url || thirdPartyTickets?.url, "_blank");
    }
  };

  const onCloseModal = () => {
    setRenderPortal(false);
  };

  return (
    <StyledMatchWatchPreWrapper>
      {firstPartyTickets?.url || thirdPartyTickets?.url ? (
        <StyledMatchWatchPre onClick={handleClick}>
          <StyledMatchCTA className="mls-c-match-list__match-cta">
            <StyledMatchWatchPreLabel className="mls-c-match-list__match-watch-label">
              {t("tickets")}
            </StyledMatchWatchPreLabel>{" "}
            {hasTicketMasterUrl ? (
              <img src={ticketMasterIconUrl} height={16} width={16} />
            ) : <TicketIconV2 width={16} height={16} viewBox="-1 0 18 18" />}
          </StyledMatchCTA>
        </StyledMatchWatchPre>
      ) : showChevron ? (
        <Chevron />
      ) : null}
      {renderPortal
        ? ReactDOM.createPortal(
          <TicketModal isOpen={renderPortal} onCloseModal={onCloseModal} />,
          document.getElementById("react-root")
        )
        : null}
    </StyledMatchWatchPreWrapper>
  );
};
